import React from "react";
import CloseIcon from "../../../components/icons/close";
import Button from "../../../components/button/button";
import Overlay from "../../../components/overlay/overlay";
import "./batch-action-modal.css";

export default function BatchActionResultsModal({
  open,
  onClose,
  results,
  title = "Resultados da Ação em Lote",
}) {
  const getStatusIcon = (status) => {
    if (status === true) {
      return "✅"; // Success
    } else {
      return "❌"; // Error
    }
  };

  const getStatusText = (status) => {
    if (status === true) {
      return "Sucesso";
    } else {
      return "Erro";
    }
  };

  const getErrorMessage = (error) => {
    const helpContent = {
      "Aguardando contato":
        "Este dispositivo ainda não conclui sua conexão com o remotize. Assim que ele contactar a plataforma com sucesso, o processo de associação será concluído.",

      "Dispositivo desconhecido":
        "Este erro ocorre quando seu dispositivo ainda não conseguiu realizar contato com a plataforma Remotize. Verifique a conexão do seu dispositivo com a internet.",

      "Dispositivo offline":
        "Dispositivo offline, verifique a conexão com a internet do dispositivo.",

      "Credenciais inválidas": "Credenciais inválidas.",

      "Dispositivo já associado": "Dispositivo já associado.",

      "Fora do padrão": "Dispositivo já está associado ou fora do padrão.",
    };

    return helpContent[error] || error;
  };

  return (
    <>
      <Overlay open={open} onClick={onClose} />
      {open && (
        <div id="batch-action-results-modal">
          <div className="close" onClick={onClose}>
            <CloseIcon size={15} />
          </div>

          <div className="device-associator-results-form">
            <div className="subtitle">{title}</div>

            <div className="results-list">
              {results.success && results.success.length > 0 && (
                <div className="results-section">
                  <h3>Dispositivos com Sucesso:</h3>
                  <ul>
                    {results.success.map((device, index) => (
                      <li key={index} className="result-item success">
                        <span className="device-id">{device.deviceid}</span>
                        <span className="status">
                          {getStatusIcon(device.status)} {getStatusText(device.status)}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {results.error && results.error.length > 0 && (
                <div className="results-section">
                  <h3>Dispositivos com Erro:</h3>
                  <ul>
                    {results.error.map((device, index) => (
                      <li key={index} className="result-item error">
                        <span className="device-id">{device.deviceid}</span>
                        <span className="status">
                          {getStatusIcon(false)} {getStatusText(false)}
                        </span>
                        <div className="error-message">
                          {getErrorMessage(device.error)}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {(!results.success || results.success.length === 0) &&
                (!results.error || results.error.length === 0) && (
                <div className="no-results">Nenhum resultado encontrado.</div>
              )}
            </div>

            <div className="modal-actions">
              <Button text="Fechar" onClick={onClose} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}